import axios, { AxiosInstance } from "axios";
let axiosInstance: AxiosInstance | null = null;

export const getAxiosInstance = (): AxiosInstance => {
  if (!axiosInstance) {
    const baseURL = getBaseUrl() + "/api";
    axiosInstance = axios.create({
      baseURL,
      headers: {
        // Include default headers here if necessary
        "Access-Control-Allow-Origin": "*",
      },
    });
  }
  return axiosInstance;
};

export const requestConfig = () => {
  const fetchedItem = localStorage.getItem("reduxState");
  const persistedState = localStorage.getItem("reduxState")
    ? JSON.parse(fetchedItem !== null ? fetchedItem : "")
    : {};

  const config = {
    headers: {
      // "Content-type": "application/json",
      Authorization: `Bearer ${persistedState?.profile?.accessToken}`,
      "Access-Control-Allow-Origin": "*",
    },
  };

  return config;
};

export const getBaseUrl = () : string => {
  let apiBaseUrl : string = "https://staging-datashaperapi.mateco-tools.qone.mateco.eu" // default
  if (window.AppConfig && window.AppConfig.API_HOST && window.AppConfig.API_HOST.length > 0) {
    apiBaseUrl = window.AppConfig.API_HOST;
  }
  return apiBaseUrl;
};